import React, { ReactElement, useContext, useEffect, useState } from 'react';
import useIsMobile from '../../../../hooks/useIsMobile';
import IconClose from '../../../../assets/new-icons/G12_X_Generico.svg';
import IconRenew from '../../../../assets/new-icons/A01_Riattiva_ricerca.svg';
import AuthContext from '../../../../contexts/authContext';
import { formatDate } from '../../../../utils/date';
import { getFromSessionStorage, setToSessionStorage } from '../../../../utils/storage.util';
import { COMPANY_PAYMENT_VIEWED } from '../../../../constants/localstorage.constants';
import { useNavigate } from 'react-router-dom';
import { evoHuntPages } from '../../../../menu';
import { isNotNullOrFalse } from '../../../../utils/string';
import { isPaymentExpired, isPaymentExpiring } from '../../../../utils/company.util';

const PlanBox = (): ReactElement => {
	const { companyPayment } = useContext(AuthContext);

	if (!companyPayment) {
		return <></>;
	}

	const navigate = useNavigate();

	const [companyPaymentViewed, setCompanyPaymentViewed] = useState<boolean>(false);

	useEffect((): void => {
		setCompanyPaymentViewed(isNotNullOrFalse(getFromSessionStorage(COMPANY_PAYMENT_VIEWED)));
	}, []);

	const [isMobile, setIsMobile] = useState(false);
	useEffect((): (() => void) => useIsMobile(setIsMobile), []);

	const handleGoToPaymentsPage = (): void => {
		navigate(`../${evoHuntPages.evohunt.subMenu.payment.path}`);
	};

	const handleViewed = (): void => {
		setCompanyPaymentViewed(true);
		setToSessionStorage(COMPANY_PAYMENT_VIEWED, true);
	};

	const isExpiring = (): boolean => {
		return isPaymentExpiring(companyPayment);
	};

	const isExpired = (): boolean => {
		return isPaymentExpired(companyPayment);
	};

	return !companyPaymentViewed ? (
		<>
			{isExpired() ||
				(isExpiring() && (
					<div className='plan-box text-center'>
						<span className='plan-box-content' style={{ fontSize: isMobile ? '1rem' : '1.5rem' }}>
							<img src={IconRenew} alt='' className='cursor-link svg-green' style={{ width: isMobile ? '1rem' : '1.5rem' }} onClick={handleGoToPaymentsPage} />
							&nbsp;&nbsp;
							{isExpiring() ? <span>Scadenza piano:&nbsp;</span> : <span>Piano scaduto in data&nbsp;</span>}
							<strong className='color-red'>{formatDate(companyPayment?.expireDate, 'DD/MM/YYYY')}</strong>&nbsp;&nbsp;
							<img src={IconClose} alt='' className='cursor-link' style={{ width: isMobile ? '1rem' : '1.25rem' }} onClick={handleViewed} />
						</span>
					</div>
				))}
		</>
	) : (
		<></>
	);
};

export default PlanBox;